import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import HomePage from './pages/HomePage';
import Players from './pages/Players';
import Parents from './pages/Parents';
import Coaches from './pages/Coaches';
import Contact from './pages/Contact';
import About from './pages/About';
import Signup from './pages/Signup';
import Competition from './pages/Competition';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import ScrollToTop from './utils/ScrollToTop';
import { JoinModalProvider } from './components/JoinModalProvider';

function App() {
  return (
    <Router>
      <JoinModalProvider>
        <ScrollToTop />
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/parents" element={<Parents />} />
          <Route path="/players" element={<Players />} />
          <Route path="/coaches" element={<Coaches />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/win-pair-of-adidas-predators" element={<Competition />} />
          <Route path="/win" element={<Competition />} />
        </Routes>
      </JoinModalProvider>
    </Router>
  );
}

export default App;
